import React, {useEffect, useState} from "react";
import {Button, Select, Tag} from "antd";
import {LifeBuoy} from "lucide-react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {AdminLayout} from "../../components/layout/AdminLayout";
import {GenericTable} from "../../components/table/GenericTable";
import {AppDispatch, RootState} from "../../redux/store";
import {getSupportTickets} from "../../redux/slice/supportTicketSlice";
import {HeroHeader, Card, SearchField, COLORS} from "../../designSystem";

function SupportTickets() {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const {token} = useSelector((state: RootState) => state.account);
  const {tickets, pageInfo, loading} = useSelector((state: RootState) => state.supportTickets);
  const [searchParam, setSearchParam] = useState("");
  const [status, setStatus] = useState<number | undefined>();

  const load = (pageNumber = 1) => {
    if (token) {
      dispatch(getSupportTickets({token, searchParam, status, pageNumber}));
    }
  };

  useEffect(() => {
    load(1);
  }, [token, searchParam, status]);

  return (
    <AdminLayout>
      <main className="h-full overflow-y-auto px-6 py-8 md:px-8" style={{background: COLORS.surface}}>
        <HeroHeader
          icon={LifeBuoy}
          title="Support Tickets"
          subtitle="Triage and respond to customer support requests."
        />

        <Card className="mt-8 p-5">
          <div className="flex flex-wrap items-center gap-3">
            <SearchField
              className="flex-1 min-w-[16rem] max-w-xl"
              placeholder="Search tickets"
              value={searchParam}
              onChange={(event) => setSearchParam(event.target.value)}
            />
            <Select allowClear value={status} onChange={setStatus} placeholder="Status" style={{width: 176, height: 44}}>
              <Select.Option value={1}>Open</Select.Option>
              <Select.Option value={2}>In Progress</Select.Option>
              <Select.Option value={3}>Resolved</Select.Option>
              <Select.Option value={4}>Closed</Select.Option>
            </Select>
          </div>
          <GenericTable
            loading={loading}
            data={tickets}
            pageInfo={pageInfo}
            handlePageChange={load}
            columns={[
            {title: "Ticket", dataIndex: "ticketNumber", key: "ticketNumber"},
            {title: "Subject", dataIndex: "subject", key: "subject"},
            {title: "User", dataIndex: "userEmail", key: "userEmail"},
            {title: "Issue", dataIndex: "issueTypeName", key: "issueTypeName"},
            {title: "Status", dataIndex: "statusName", key: "statusName", render: (value: string) => <Tag>{value}</Tag>},
            {title: "Created", dataIndex: "createdAt", key: "createdAt", render: (value: string) => new Date(value).toLocaleString()},
            {title: "Action", key: "action", render: (_: any, row: any) => <Button onClick={() => navigate(`/support-tickets/${row.id}`)}>Review</Button>},
            ]}
          />
        </Card>
      </main>
    </AdminLayout>
  );
}

export default SupportTickets;
